import { useState } from "react"

import { ParadiseSearchMultiSelect } from "src/components/Paradise/ParadiseSearchMultiSelect"
import { pointEventTypes } from "src/data/devices/logic/deviceLogic"

export function ParadiseEventTypeFilter({
  selectedEventTypes,
  setSelectedEventTypes,
}: {
  selectedEventTypes: string[]
  setSelectedEventTypes: (selectedEventTypes: string[]) => void
}) {
  const entries = Object.entries(pointEventTypes)
  const [searchValue, setSearchValue] = useState("")

  const filteredEntries = entries.filter(([_key, value]) =>
    value.toLowerCase().includes(searchValue.toLowerCase())
  )

  return (
    <ParadiseSearchMultiSelect
      options={filteredEntries.map(([key, value]) => ({
        label: value,
        value: key,
      }))}
      selectedValues={selectedEventTypes}
      onChange={setSelectedEventTypes}
      onSearch={setSearchValue}
      isLoading={false}
      placeholder="Search by event type"
    />
  )
}
